import React, { Component } from 'react'
import Outernavbar from './outernavbar.component'
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';

export default class VerifyOtp extends Component {
    constructor(props) {
        super(props)
        const udata = localStorage.getItem('user')
        let loggedIN = true
        if (udata == null) {
            loggedIN = false
        }
        this.onChangeotp = this.onChangeotp.bind(this);
        
       
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            otp: '',
            password: '',
            loggedIN,
            errorMessage: '', // New state for error message
            loading: false // New state for loading spinner
        }
    }

    onChangeotp(e) {
        this.setState({ otp: e.target.value })
    }

    

    
   
    onSubmit(e) {
        e.preventDefault()

        this.setState({ loading: true }); // Show spinner when form is submitted

        const userObject = {
            email: sessionStorage.getItem("resetEmail"),
            otp: this.state.otp
        };
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/verify-otp`, userObject)
            .then((res) => {
                if (res.status === 200) {

                     sessionStorage.setItem("resetOtp", this.state.otp);


                    this.setState({
                        loggedIN: true,
                        errorMessage: '', // Clear error message on success
                        loading: false // Hide spinner on success
                    })
                   // localStorage.setItem('user', JSON.stringify(res.data))
                }
            }).catch((error) => {
                this.setState({
                    errorMessage: "Wrong email or password", // Set error message
                    loading: false // Hide spinner on error
                })
            });
        this.setState({ email: '', password: '' })
    }

    render() {
        if (this.state.loggedIN) {
            return <Navigate to="/reset-password" />
        }
        return (
            <div className='App'>
                <Outernavbar />
                <div className="auth-wrapper">
                    <div className="auth-inner">
                        <form onSubmit={this.onSubmit}>

                            <h3>Verify Otp </h3>
                            <p className="forgot-password text-right">
                                Don't have an account <a href="/sign-up">join us?</a>
                            </p>
                            <div className="mb-3">
                                <label>Enter OTP</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter OTP"
                                    onChange={this.onChangeotp}
                                    name="otp"
                                    value={this.state.otp}
                                />
                            </div>
                            
                            
                            {this.state.errorMessage && (
                                <div className="alert alert-danger" role="alert">
                                    {this.state.errorMessage}
                                </div>
                            )}
                            <div className="d-grid">
                                <button type="submit" className="btn btn-primary" disabled={this.state.loading}>
                                    {this.state.loading ? (
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    ) : 'Submit'}
                                </button>
                            </div>
                        </form>
                        <GoogleOAuthProvider clientId="386932037035-k8v833noqjk7m4***********.apps.googleusercontent.com">
                            <React.StrictMode>
                                <App />
                            </React.StrictMode>
                        </GoogleOAuthProvider>
                    </div>
                </div>
            </div>
        )
    }
}
